import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { InterviewAdvanceSearchService } from "../../../services/InterviewAdvanceSearch";
import { InterviewService } from "../../../services/InterviewService";
import { DropDownQuickSearchOptions } from "./DropDownSearchOption";
import { FieldNames } from "./FieldNames";
import { CommonService } from "../../../services/CommonService";

const advanceSearchContext = createContext();
export default function AdvanceSearchContextProvider({ children }) {
  const [personalSkills, setpersonalSkills] = useState([]);

  const [searchObject, setSearchObject] = useState({
    skills: [],
    zones: [],
    jobRoles: [],
    managerInterestId:[],
    yearsOfExperienceOptions: [],
    seniorityLevels: [],
    pageNumber: 1,
    selectedFilters: [],
    languageLevels: [],
    orderBy: "ModifiedDate",
    order: 1,
    tags: []
  });
  const [activeTab, setActiveTab] = useState("search");
  const FIXEDSEARCHFIELDSIDS = [
    FieldNames.professionalExperienceYearsId,
    FieldNames.zoneId,
    FieldNames.mobility,
    FieldNames.skills,
    FieldNames.languageId,
    FieldNames.availability,
    FieldNames.expectedSalary,
    FieldNames.remoteWorkId,
    FieldNames.rating,
    FieldNames.jobRoleId
  ];
  const [pageSize, setPageSize] = useState(10);
  const PAGE_ONE = 1;
  const [pageNumber, setPageNumber] = useState(1);
  const [interviews, setInterviews] = useState([]);
  const [totalpages, setTotalPages] = useState(0);
  const [showSaveFilters, setShowSaveFilters] = useState(false);
  const [searchOptions] = useState(DropDownQuickSearchOptions.getOptions());
  let fixedSearchFields = loadFixedFilterComponents();
  const [activeFilters, setActiveFilters] = useState(fixedSearchFields);
  const [selectableFilters, setSelectableFilters] = useState(
    loadSelectableFilters
  );

  const [filtersSettings, setFiltersSettings] = useState([]);
  const { t } = useTranslation();
  const [errors, setErrors] = useState([]);
  
  const validateErrors = () => {
    const _errors = {};
    if(searchObject.languageId && searchObject.languageLevels.length === 0){
      _errors.languageLevels = t("At least one level must be selected");
    }
    if(!searchObject.languageId && searchObject.languageLevels.length >= 1){
      _errors.languageId = t("You must choose a language.");
    }
    setErrors(_errors);
    return Object.keys(_errors).length > 0;
  }

  useEffect(() => {
    loadFilters();
  }, []);

  useEffect(
    () => CommonService.getAllSkills().then((data) => setpersonalSkills(data)),
    []
  );

  function loadFixedFilterComponents() {
    let list = [];
    for (let input of FIXEDSEARCHFIELDSIDS) {
      for (let option of searchOptions) {
        if (option.id === input) {
          list.push(option);
          break;
        }
      }
    }
    return list;
  }

  function onChangeSelectableFilters(selectedFilters) {
    setActiveFilters(selectedFilters);
  }

  function loadSelectableFilters() {
    return searchOptions;
  }

  function initiatePersonalSkills() {
    if (personalSkills && personalSkills.length > 0) {
      let _personnalSkills = personalSkills.map((skill) => {
        return {
          description: skill.description,
          id: skill.id,
          rating: 0
        };
      });
      return _personnalSkills;
    }
  }

  function loadFilters() {
    InterviewAdvanceSearchService.getFilters().then((data) =>
      updateSettings(data)
    );
  }

  function updateSettings(settings) {
    let activefiltertemplate = settings.filter((filter) => filter.active);
    if (activefiltertemplate[0])
      loadInputFilters(activefiltertemplate[0].filters);
    setFiltersSettings(settings);
  }
  function loadInputFilters(filters) {
    let filterNames = filters.map((filter) => filter.filterId);
    let selecteds = searchOptions.filter((option) =>
      filterNames.includes(option.id)
    );
    setActiveFilters(selecteds);
  }

  function onChange({ target }) {
    if (target.value)
      setSearchObject({
        ...searchObject,
        [target.name]: target.value
      });
    else {
      setSearchObject({
        ...searchObject,
        [target.name]: undefined
      });
    }
  }

  function updateFilter(event, filterName) {
    if (event.target.checked)
      InterviewAdvanceSearchService.updateFilter(filterName).then((data) => {
        updateSettings(data);
      });
    else
      InterviewAdvanceSearchService.updateFilter("").then((data) => {
        updateSettings(data);
      });
  }

  function deleteFilter(event, filterName) {
    event.stopPropagation();
    InterviewAdvanceSearchService.deleteFilter(filterName).then((data) => {
      updateSettings(data);
    });
  }

  function onSaveFilters(filterName) {
    InterviewAdvanceSearchService.saveFilter(
      activeFilters.map((filter) => filter.id),
      filterName
    ).then((data) => {
      // set saved FilterList Data
      updateFilter({ target: { checked: true } }, filterName);
      setShowSaveFilters(false);
    });
  }

  function onRemoveSelected(filterName) {
    let _searchObject = { ...searchObject };
    switch (filterName) {
      case FieldNames.betweenDates:
        _searchObject["endingDate"] = undefined;
        _searchObject["startingDate"] = undefined;
        break;
      case FieldNames.skills:
        _searchObject["skills"] = [];
        break;
      case FieldNames.businessArea:
        _searchObject["businessArea"] = [];
        break;
      case FieldNames.techArea:
        _searchObject["techArea"] = [];
        break;
      case FieldNames.techRole:
        _searchObject["techRole"] = [];
        break;
      case FieldNames.jobRoleId:
        _searchObject["jobRoles"] = [];
        break;
      case FieldNames.candidateInterestBusinessArea:
        _searchObject["candidateInterestBusinessArea"] = [];
        break;
      case FieldNames.candidateInterestTechArea:
        _searchObject["candidateInterestTechArea"] = [];
        break;
      case FieldNames.candidateInterestTechRole:
        _searchObject["candidateInterestTechRole"] = [];
        break;
      case FieldNames.zoneId:
        _searchObject["zones"] = [];
      break;
      case FieldNames.professionalExperienceYearsId:
      _searchObject["yearsOfExperienceOptions"] = [];
        break;
      case FieldNames.tags:
        _searchObject["tags"] = [];
          break;
      case FieldNames.managerInterestId:
        _searchObject["managerInterestId"] = [];
        break;
      case FieldNames.seniorityLevelsId:
        _searchObject["seniorityLevel"] = [];
          break;
      case FieldNames.languageLevelId:
      _searchObject["languageLevels"] = [];
        break;
      case FieldNames.competences:
        _searchObject.personalSkills = initiatePersonalSkills();
        break;
      case FieldNames.CurrentSalary:
        _searchObject["lowerBoundCurrentSalary"] = undefined;
        _searchObject["upperBoundCurrentSalary"] = undefined;
        break;
      case FieldNames.expectedSalary:
        _searchObject["lowerBoundSalary"] = undefined;
        _searchObject["upperBoundSalary"] = undefined;
        break;
      case FieldNames.availability:
        _searchObject["availability"] = undefined;
        _searchObject["noticeId"] = undefined;
        break;
      case FieldNames.birthDate:
        _searchObject["birthDateEnd"] = undefined;
        _searchObject["birthDateStart"] = undefined;
        break;
      case FieldNames.coursebyDate:
        _searchObject["courseStartDate"] = undefined;
        _searchObject["courseEndDate"] = undefined;
        break;
      case FieldNames.languageId:
        _searchObject["languageId"] = undefined;
        _searchObject["languageLevelId"] = undefined;
        break;
      default:
        _searchObject[filterName] = undefined;
        break;
    }
    setSearchObject(_searchObject);
  }

  function clear() {
    let _searchObject = {
      skills: [],
      orderby: "ModifiedDate",
      managerInterestId:[],
      order: 1,
      zones: [],
      yearsOfExperienceOptions: [],
      languageLevels: [],
      seniorityLevels: [],
      jobRoles: [],
      tags: []
    };
    setErrors({});
    _searchObject.personalSkills = initiatePersonalSkills();
    setSearchObject(_searchObject);
  }

  function executeSearch() {
    if(validateErrors()){
      return;
    }
    if (pageNumber === PAGE_ONE) search(searchObject);
    else setPageNumber(PAGE_ONE);
  }

  function formatRequest(_searchObject) {
    let formated = { ..._searchObject };

    if (formated.personalSkills)
      formated.personalSkills = formated.personalSkills.filter(
        (skill) => skill.rating > 0
      );
    formated.skills = formated.skills.map((skill) => skill.id);
    formated.zones = formated.zones.map((zone) => zone.id);
    formated.managerInterestId = formated.managerInterestId.map((managerInterest) => managerInterest.id);
    formated.yearsOfExperienceOptions = formated.yearsOfExperienceOptions.map((yearsOfExperience) => yearsOfExperience.id);
    formated.seniorityLevels = formated.seniorityLevels.map((seniorityLevels) => seniorityLevels.id);
    formated.languageLevels = formated.languageLevels.map((languageLevel) => languageLevel.id);
    formated.jobRoles = formated.jobRoles.map((jobRole) => jobRole.id);
    formated.tags = formated.tags.map((tags) => (tags.id))
    return formated;
  }

  function sort(_searchObject) {
    setInterviews([]);
    setSearchObject(_searchObject);
    search(_searchObject);
  }

  function search(_searchObject) {
    _searchObject = formatRequest(_searchObject);
    InterviewService.advanceSearch(
      _searchObject,
      pageSize,
      pageNumber
    ).then((data) => {
      setInterviews(data.page);
      setTotalPages(Math.ceil(data.total / pageSize));
      setActiveTab("searchResults");
      if (data.total === 0) toast.warning(t("No results found."));
    });
  }

  const firstLoad = useRef(true);
  useEffect(() => {
    if (firstLoad.current) firstLoad.current = false;
    else {
      search(searchObject);
    }
  }, [pageNumber, pageSize]);

  return (
    <advanceSearchContext.Provider
      value={{
        searchObject,
        setSearchObject,
        onChange,
        activeFilters,
        setActiveFilters,
        t,
        searchOptions,
        loadFilters,
        updateFilter,
        deleteFilter,
        filtersSettings,
        onSaveFilters,
        showSaveFilters,
        setShowSaveFilters,
        initiatePersonalSkills,
        onRemoveSelected,
        clear,
        activeTab,
        setActiveTab,
        totalpages,
        setPageNumber,
        pageNumber,
        interviews,
        sort,
        onChangeSelectableFilters,
        executeSearch,
        setPageSize,
        selectableFilters,
        setSelectableFilters, 
        errors
      }}
    >
      {children}
    </advanceSearchContext.Provider>
  );
}
export function useAdvanceSearchContext() {
  const context = useContext(advanceSearchContext);
  return context;
}
